import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import Image from 'yoda-core-components/lib/components/Image/Image';
import filterImageUrlExtension from '../../utils/FilterImageUrlExtension';
import * as styles from '../ProductDetails/ProductDetails.css';

const cx = classNames.bind(styles);

function ProductMiniDetails({ productItem }) {
    if (!productItem) {
        return null;
    }

    return (
        <div className={cx('productDetailsWrap')} data-automation-id="at-productDetails-mini-Wrap">
            <div data-automation-id="at-product-mini-image" className={cx('productImageBlock')}>
                <Image
                    src={filterImageUrlExtension(productItem.imageURL)}
                    theme={cx('productImage')}
                    alt={productItem.name}
                />
            </div>
            <div className={cx('productInfoBlock')}>
                <div data-automation-id="at-product-mini-name">{productItem.name}</div>
                <div
                    className={cx('productAttributesBlock')}
                    data-automation-id="at-product-mini-quantity"
                >
                    Qty: {productItem.quantity}
                </div>
            </div>
        </div>
    );
}

ProductMiniDetails.propTypes = {
    productItem: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default ProductMiniDetails;
